<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Navigation from './components/navigation'
import Footer from './components/footer'
import 'es6-promise/auto'

export default {
  components: {
    Footer,
    Navigation },
  name: 'app',
  created: function () {
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue